import React, { useState, useEffect } from 'react';
import { withRouter, useHistory, useParams } from 'react-router-dom';
import { Alert, Button, Layout, Row, Col, Card } from 'antd';
import { PageDetails } from '../components/[pageId]/PageDetails';
import { PageTransactions } from '../components/[pageId]/PageTransactions';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../helpers/appDispatch';
import { appSelector } from '../helpers/appSelector';
import { getPageTranxRequest, clearStates } from '../store/payment-pages';
import { path } from '../helpers/path';

interface PageProps {}

interface ParamProps {
  pageId: string;
}

const Page: React.FC<PageProps> = () => {
  const { Content } = Layout;
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const { pageId } = useParams<ParamProps>();
  const page = appSelector((state) => state.page);
  const [pageSize, setPageSize] = useState(10);
  const [skip, setSkip] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const { pageTransactions, pageTransactionsTotal, loading, pageTransactionsError } = page;

  const getErrorMessage = (err: any) => {
    if (typeof err === 'string') return err;
    return err?.detail || err?.message || err?.title || JSON.stringify(err);
  };

  useEffect(() => {
    dispatch(clearStates());
    dispatch(
      getPageTranxRequest({
        product: pageId,
        periodFrom: '',
        periodTo: '',
        pageSize,
        skip
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onLoadMore = (page: number, size: number) => {
    const newSkip = page - 1;
    setPageSize(size);
    setSkip(newSkip);
    setCurrentPage(page);
    dispatch(
      getPageTranxRequest({
        product: pageId,
        periodFrom: '',
        periodTo: '',
        pageSize: size,
        skip: newSkip
      })
    );
  };

  return (
    <div className="padding-box">
      <Content className="site-layout-background site-box">
        <div className="margin-top">
          <Row style={{ marginBottom: 16 }}>
            <Button onClick={() => history.push(path.paymentPages)}>
              Back
            </Button>
          </Row>
          {pageTransactionsError && (
            <Alert
              message="Failed to load data"
              description={getErrorMessage(pageTransactionsError)}
              type="error"
              showIcon
              style={{ marginBottom: 16 }}
            />
          )}
          <Card>
            <Row>
              <Col
                span={12}
                style={{ padding: 24 }}
                className="site-layout-background"
              >
                <PageDetails />
              </Col>
              <Col span={12} className="bg-gray" style={{ padding: 24 }}>
                <PageTransactions
                  loading={loading}
                  transactions={pageTransactions}
                  total={pageTransactionsTotal}
                  currentPage={currentPage}
                  onLoadMore={onLoadMore}
                />
              </Col>
            </Row>
          </Card>
        </div>
      </Content>
    </div>
  );
};

export default withRouter(Page);
